export const taskHasDifferentDescriptions = (task) => {
    if (!task.GroupGuid) {
        return false
    }
    const descriptions = new Set([...task.RelatedEvents.map(re => re.Description), task.Description])
    return (descriptions.size > 1)
}